

// Aos animation install
 AOS.init();


document.addEventListener('DOMContentLoaded', function () {
    // Trending Products Slider
    const trendingSlider = document.querySelector('.trending-product-slider');
    if (trendingSlider) {
        new Splide(trendingSlider, {
            type: 'loop',
            perPage: 3,
            gap: 30,
            pagination: true, // Enable dots
            arrows: false,    // Disable arrows
            drag: true,
            updateOnMove: true,
            breakpoints: {
                989: { 
                  perPage: 2,
                  gap: 10
                }, // Smaller screens show fewer slides
            },
        }).mount();
    }

    // Testimonials Slider
    const testimonialsSlider = document.querySelector('.testimonials-slider');
    if (!testimonialsSlider) return; // Stop if slider is missing

    const splide = new Splide(testimonialsSlider, {
        type: 'slide', // No loop
        perPage: 3,
        gap: 30,
        pagination: false,
        arrows: false, // Disable default arrows
        drag: true,
        updateOnMove: true,
        breakpoints: {
            1199: { perPage: 2 },
            600: { perPage: 1 },
        },
    });

    splide.mount();

    // Custom Arrows
    const leftArrow = document.querySelector('.left-arrow-wrap');
    const rightArrow = document.querySelector('.right-arrow-wrap');

    if (!leftArrow || !rightArrow) return; // Stop if arrows are missing

    function updateArrows() {
        const index = splide.index;
        const lastIndex = splide.Components.Controller.getEnd(); // Get last slide index

        leftArrow.classList.toggle('active', index > 0);
        rightArrow.classList.toggle('active', index < lastIndex);
    }

    splide.on('move', updateArrows);
    updateArrows(); // Run once on load

    // Arrow Click Events
    leftArrow.addEventListener('click', function () {
        if (leftArrow.classList.contains('active')) {
            splide.go('<');
        }
    });

    rightArrow.addEventListener('click', function () {
        if (rightArrow.classList.contains('active')) {
            splide.go('>');
        }
    });
});



// product page faq

     document.querySelectorAll(".faq-heading").forEach(function (item){
        item.addEventListener("click", function (){
         this.parentElement.classList.toggle("active");

          // hide show div
         const nextdiv = this.nextElementSibling;
          if (window.getComputedStyle(nextdiv).display == "none"){
               nextdiv.style.display = "block";

          }else{
               nextdiv.style.display = "none";
          }


         // sibling process
         const topparent = this.parentElement.parentElement.children;
        
         for( let i=0; i < topparent.length; i++){  
          const siblingcount = topparent[i]; 
             
            if(siblingcount != this.parentElement){
               siblingcount.classList.remove("active");
               const dataText = siblingcount.querySelector(".faq-text");
                dataText.style.display = "none";
            }
         }           
  });
});


// product page view all photo script

function ViewAllPhoto() {
document.addEventListener("DOMContentLoaded", function () {
  let items = document.querySelectorAll(".pro-grid"); // Select all image items
  let loadButton = document.getElementById("load");
  let initialItems = 4; // Show 3 items initially
  let loadMoreItems = 20; // Show 4 more per click

  if (items.length === 0) return; // Exit if no images found

  // Hide all items except the first 3
  items.forEach((item, index) => {
    item.style.display = index < initialItems ? "flex" : "none";
  });

  // Hide the load button by default
  if (loadButton) {
    loadButton.style.display = items.length > initialItems ? "flex" : "none";

    // Click event for loading more images
    loadButton.addEventListener("click", function (e) {
      e.preventDefault();

      let hiddenItems = Array.from(items).filter(item => item.style.display === "none");

      hiddenItems.slice(0, loadMoreItems).forEach(item => {
        item.style.display = "flex";
      });

      // Hide button if no more hidden items left
      if (hiddenItems.length <= loadMoreItems) {
        loadButton.style.display = "none";
      }
    });
  }
});

};

// // function calling
// ViewAllPhoto();


// function ViewAllPhotoForClick() {
//   let items = document.querySelectorAll(".pro-grid"); // Select all image items
//   let loadButton = document.getElementById("load");
//   let initialItems = 4; // Show 3 items initially
//   let loadMoreItems = 20; // Show 4 more per click

//   if (items.length === 0) return; // Exit if no images found

//   // Hide all items except the first 3
//   items.forEach((item, index) => {
//     item.style.display = index < initialItems ? "block" : "none";
//   });

//   // Hide the load button by default
//   if (loadButton) {
//     loadButton.style.display = items.length > initialItems ? "block" : "none";

//     // Click event for loading more images
//     loadButton.addEventListener("click", function (e) {
//       e.preventDefault();

//       let hiddenItems = Array.from(items).filter(item => item.style.display === "none");

//       hiddenItems.slice(0, loadMoreItems).forEach(item => {
//         item.style.display = "block";
//       });

//       // Hide button if no more hidden items left
//       if (hiddenItems.length <= loadMoreItems) {
//         loadButton.style.display = "none";
//       }
//     });
//   }

// };


setTimeout(function() {
    const div = document.querySelector('.product .product__media-wrapper ul.product__media-list li.product__media-item:nth-child(4)');
    const divHei = div ? div.offsetHeight : 0;
    const allPhotoWrap = document.querySelector('.all-photo-wrap');
    if (allPhotoWrap) {
    allPhotoWrap.style.height = divHei + 'px';
}
}, 200);










